import { render, staticRenderFns } from "./PleitosLista.vue?vue&type=template&id=89c1e4c8"
import script from "./PleitosLista.vue?vue&type=script&lang=js"
export * from "./PleitosLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports